export interface WhitelistCategoryMeta {
  id: string;
  title: string;
}

export const WHITELIST_CATEGORIES: WhitelistCategoryMeta[] = [
  { id: "liquidator", title: "Liquidator" },
  { id: "price-monitor", title: "Price monitor" },
  { id: "insolvency-monitor", title: "Insolvency monitor" },
];
